module.exports = __webpack_public_path__ + "img/pencil-lines.861f65e.svg";